// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    margin-bottom: 15px;
    margin-top: 10px;
    border-radius: 10px;
    background-color: #fcfaf5;
    width: 650px;
    padding-left:5px;
}

.admin-container-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
}

.shadow-box {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
}

.abosulte-container {
    position: absolute;
    width: 100vw;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.has_refresh_signal {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.center-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/communication-management/communication-management.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wFAAwF;IACxF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B","sourcesContent":[".admin-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    margin-bottom: 15px;\n    margin-top: 10px;\n    border-radius: 10px;\n    background-color: #fcfaf5;\n    width: 650px;\n    padding-left:5px;\n}\n\n.admin-container-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.shadow-box {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n}\n\n.abosulte-container {\n    position: absolute;\n    width: 100vw;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.has_refresh_signal {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n}\n\n.center-column {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
